import { createSlice } from "@reduxjs/toolkit";
import {
  userSignin,
  getMe,
  organizationRegister,
  organizationLogin,
} from "./authActions";
import LocalStorageService from "../../common/services/LocalStorageService";

// initialize userToken from local storage
const userToken = LocalStorageService?.get("authorizationData")
  ? LocalStorageService?.get("authorizationData")?.access
  : null;

const initialState = {
  loading: false,
  user: null,
  userToken: userToken ? userToken : "",
  error: null,
  success: false,
  isAuthenticated: userToken ? true : false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    resetAuthError: (state, action) => {
      if (action?.payload && state.error && typeof state.error === "object") {
        delete state.error[action.payload];
        if (Object.keys(state.error).length === 0) {
          state.error = null;
        }
      } else if (!action?.payload) {
        state.error = null;
      }
      state.loading = false;
      state.success = false;
    },
    logOut: (state) => {
      state.success = false;
      state.error = null;
      state.userToken = null;
      state.user = null;
      state.loading = false;
      state.isAuthenticated = false;
      LocalStorageService.remove("authorizationData");
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(userSignin.pending, (state) => {
        state.loading = true;
      })
      .addCase(userSignin.fulfilled, (state, action) => {
        state.user = action?.payload?.user?.patient;
        state.userToken = action.payload.access;
        state.isAuthenticated = true;
        state.loading = false;
        state.success = true;
        state.user = action?.payload?.user;
      })
      .addCase(userSignin.rejected, (state, action) => {
        state.error = action.payload;
        state.isAuthenticated = false;
        state.loading = false;
        state.user = null;
      })
      .addCase(organizationLogin.pending, (state) => {
        state.loading = true;
      })
      .addCase(organizationLogin.fulfilled, (state, action) => {
        state.user = action?.payload?.organization;
        state.userToken = action?.payload?.tokens?.access;
        state.isAuthenticated = true;
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(organizationLogin.rejected, (state, action) => {
        state.error = action.payload;
        state.isAuthenticated = false;
        state.loading = false;
        state.user = null;
      })
      .addCase(organizationRegister.pending, (state) => {
        state.loading = true;
      })
      .addCase(organizationRegister.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
        state.success = true;
      })
      .addCase(organizationRegister.rejected, (state, action) => {
        state.error = action?.payload;
        state.isAuthenticated = false;
        state.loading = false;
      })
      .addCase(getMe.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMe.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
      })
      .addCase(getMe.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});
export const { resetAuthError, logOut } = authSlice.actions;
export default authSlice.reducer;
